const SubscribeEndpoints = {
  getSubscribeList: {
    method: "GET",
    url: `/subscribe`,
  },
  addSubscibe: {
    method: "POST",
    url: `/landing-page/subscribe`,
  },
};

export default SubscribeEndpoints;
